import React, { useEffect, useCallback } from 'react';
import { useFiltersContext } from '@components/BestVarieties';
import Slugify from '@js/utils/Slugify';
import { FILTERS } from '../../constants';
import { FormProvider, useForm } from 'react-hook-form';
import { ReactComponent as IconClose } from '@icons/close.svg';

const DEFAULT_FORM = {
  'precocite-maturite': false,
  'vigueur-de-depart': false,
  'indice-de-masse-foliaire': false,
  'resistance-mildiou': false,
  'tolerance-verticillium': false,
  'tolerance-phomopsis': false,
  "comportement-a-lorobanche": false,
  'richesse-huile': false
}

function FiltersPanel({
  toggleFilters,
  setToggleFilters,
}) {
  const { filters, setFilters } = useFiltersContext();

  const methods = useForm({
    defaultValues: Object
      .entries(filters)
      .reduce((acc, [key, value]) => ({
        ...acc,
        [FILTERS[key].key]: value
      }), DEFAULT_FORM)
  });

  const onValid = (data) => {
    const filtersToSet = Object.entries(data).reduce((acc, [key, value]) => {
      const filterKey = Object
        .entries(FILTERS)
        .find(([,entry]) => key === entry.key)[0];
      if (value !== false) return {
        ...acc, [filterKey]: value
      }
      return acc;
    }, {})
    setFilters(filtersToSet);
    setToggleFilters(false);
  }

  const onOutsideClick = useCallback((e) => {
    if (!e.target.closest('.OverlayFilters')) setToggleFilters(false);
  }, [setToggleFilters]);

  useEffect(() => {
    if (toggleFilters) {
      document.body.classList.add('overflow-hidden');
      document.body.classList.add('is-open');
      document.addEventListener('click', onOutsideClick);
    }
    else {
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('is-open');
      document.removeEventListener('click', onOutsideClick);
    }
  }, [toggleFilters, setToggleFilters, onOutsideClick]);

  return (
    <FormProvider {...methods}>
      <div className={`FiltersPanel OverlayFilters ${toggleFilters ? 'open' : ''}`}>
        <div className="flex justify-between w-full OverlayFilters-header">
          <p className="font-semibold">Filtres</p>
          <button onClick={() => {
            setToggleFilters(false);
          }}>
            <IconClose className="w-6 h-w-6" />
          </button>
        </div>
        <form
          className="flex flex-col flex-1 overflow-hidden FiltersPanel-form"
          onSubmit={methods.handleSubmit(onValid)}>
          <div className="OverlayFilters-items">
            {Object.entries(FILTERS).map(([name, { key, value }]) => (
              <React.Fragment key={`filter-${key}`}>
                <div className="OverlayFilters-itemsCategory">
                  <div className="OverlayFilters-itemsCategoryTitleWrapper">
                    <p className="OverlayFilters-itemsCategoryTitle">
                      {name}
                    </p>
                  </div>
                </div>
                {
                  value?.map((value, index) => (
                    <div className="OverlayFilters-itemsCategoryCheckbox" key={`checkbox-${Slugify(value)}-${index}`}>
                      <div className="flex CheckboxContainer">
                        <input
                          type="checkbox"
                          {...methods.register(key)}
                          id={`${key}-${Slugify(value)}`}
                          className="Checkbox"
                          value={value} />
                        <label
                          htmlFor={`${key}-${Slugify(value)}`}
                          className="ml-3 leading-tight text-gray-600">
                            {value}
                        </label>
                      </div>
                    </div>
                  ))
                }
              </React.Fragment>
            ))}
          </div>
          <div className="OverlayFilters-footer active">
            <button type="button" className="OverlayFilters-footerReset" onClick={() => {
              methods.reset(DEFAULT_FORM);
              setFilters({});
              setToggleFilters(false);
            }}>Réinitialiser les filtres</button>
            <button
            type="submit"
            className="ml-auto OverlayFilters-footerBtn btn btn--rounded">Valider</button>
          </div>
        </form>
      </div>
    </FormProvider>
  )
};

export default FiltersPanel;
